module.exports = __webpack_public_path__ + "static/media/porte2.c9554778.jpg";